module.exports = __webpack_public_path__ + "fonts/Inter-ExtraBold.92d16ae.woff2";